module.exports = __webpack_public_path__ + "f7d708e80723d26db791c539df9d72e7.svg";